export function dashboardPayrollProcessingItemTemplate($templateCache) {
    'ngInject';
    const path = "/Scripts/Page/Home/apex-dashboard-item-template-payroll-processing.html";
    const html = /*html*/`<apex-payroll-processor-dashboard employee-id="vm.employeeID">
        </apex-payroll-processor-dashboard>`;
    $templateCache.put(path, html);
}

export function dashboardPayrollProcessingListItemTemplate($templateCache) {
    'ngInject';
    const path = "/Scripts/Page/Home/apex-dashboard-list-item-template-payroll-processing.html";
    const html = /*html*/`
        <span ng-if="dashboard.count === 0">
            All payrolls are processed
        </span>
        <span ng-if="dashboard.count > 0">
            There are unprocessed payrolls available for processing
        </span>`;
    $templateCache.put(path, html);
}
